import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAppSelector } from '@app/store/hooks';
import { paths } from '@shared/config/paths';
import { selectIsAuthenticated, selectIsRestoring } from '../store/authSlice';

/**
 * Protège une route : redirige vers /login si non authentifié.
 * Affiche un écran de chargement pendant la restauration de la session.
 */
export function RequireAuth({ children }: PropsWithChildren) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const restoring = useAppSelector(selectIsRestoring);
  const location = useLocation();

  if (restoring) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p role="status" className="text-sm text-slate-500">
          Chargement de la session…
        </p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.login} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
